// extracted by mini-css-extract-plugin
export var cell = "_56-4";
export var headerCell = "_56-2";
export var rowHeader = "_56-3";
export var table = "_56-1";
export var tableContainer = "_56-0";